import {
  requestSecurityEmail as requestSecurityEmailService,
  exchangeToken as exchangeTokenService,
  getFormData as getFormDataService,
  putFormData as putFormDataService,
  submitForm as submitFormService,
  getQuestionnaire as getQuestionnaireService,
  getValidation as getValidationService,
} from './service';
import {
  PART_A_GET_AUTH_TOKEN_REQUEST,
  PART_A_GET_AUTH_TOKEN_FAILURE,
  PART_A_GET_AUTH_TOKEN_SUCCESS,
  PART_A_REQUEST_SECURITY_EMAIL_REQUEST,
  PART_A_REQUEST_SECURITY_EMAIL_FAILURE,
  PART_A_REQUEST_SECURITY_EMAIL_SUCCESS,
  PART_A_GET_DATA_REQUEST,
  PART_A_GET_DATA_SUCCESS,
  PART_A_GET_DATA_FAILURE,
  PART_A_SAVE_DATA_REQUEST,
  PART_A_SAVE_DATA_SUCCESS,
  PART_A_SAVE_DATA_FAILURE,
  PART_A_CLEAR_TOKEN,
  PART_A_RESET,
  PART_A_SCREEN_STATE,
  PART_A_SUBMIT_FORM_REQUEST,
  PART_A_SUBMIT_FORM_SUCCESS,
  PART_A_SUBMIT_FORM_FAILURE,
} from '../../actions/actionTypes';

export function setScreenState(screenState) {
  return { type: PART_A_SCREEN_STATE, payload: screenState };
}

export function resetStatus() {
  return { type: PART_A_RESET, payload: { statusOnly: true } };
}

export function submitForm(token) {
  return {
    types: [PART_A_SUBMIT_FORM_REQUEST, PART_A_SUBMIT_FORM_SUCCESS, PART_A_SUBMIT_FORM_FAILURE],
    promise: submitFormService(token),
  };
}

export function putFormData(token, data, answers) {
  return function (dispatch, getState) {
    dispatch({ type: PART_A_SAVE_DATA_REQUEST });
    return putFormDataService(data, token)
      .then((response) => {
        dispatch({ type: PART_A_SAVE_DATA_SUCCESS });
        return answers;
      })
      .catch((e) => {
        dispatch({ type: PART_A_SAVE_DATA_FAILURE, payload: e });
        // console.info('>>> putFormData error', e)
        return null;
      });
  };
}

export function getFormData(token) {
  return function (dispatch, getState) {
    // dispatch({ type: PART_A_CLEAR_TOKEN });
    // dispatch(resetStatus())
    dispatch({ type: PART_A_GET_DATA_REQUEST });
    return getFormDataService(token)
      .then((response) => {
        dispatch({ type: PART_A_GET_DATA_SUCCESS });
        return response?.formData || [];
      })
      .catch((e) => {
        dispatch({ type: PART_A_GET_DATA_FAILURE, payload: e });
        // console.info('>>> getFormData error', e)
        return [];
      });
  };
}

export function getQuestionnaire(token) {
  return function () {
    return getQuestionnaireService(token);
  };
}

export function validateForm(token) {
  return function () {
    return getValidationService(token);
  };
}

export function exchangeToken(token) {
  return function (dispatch, getState) {
    dispatch({ type: PART_A_GET_AUTH_TOKEN_REQUEST });
    return exchangeTokenService(token)
      .then((response) => {
        dispatch({ type: PART_A_GET_AUTH_TOKEN_SUCCESS, payload: response });
        return response;
      })
      .catch((e) => {
        dispatch({ type: PART_A_GET_AUTH_TOKEN_FAILURE, payload: e });
        return null;
      });
  };
}

export function requestSecurityEmail(email, mode) {
  return {
    types: [
      PART_A_REQUEST_SECURITY_EMAIL_REQUEST,
      PART_A_REQUEST_SECURITY_EMAIL_SUCCESS,
      PART_A_REQUEST_SECURITY_EMAIL_FAILURE,
    ],
    promise: requestSecurityEmailService(email, mode),
  };
}
